import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { ComponentBase, DialogData } from '@definitiv-packages/angular-dba-library';
import { Document, DocumentService } from '@definitiv-packages/angular-documents-library';

import { CreateSafetyPointComponent, DocumentDataType, ObjektModel, ObjektService, ProjectLanguage, RoofareaModel, RoofareaModelView, RoofareaService, SafetyPointModelView, SafetyPointViewService, SicherungssystemModelView, SicherungssystemViewService } from '../../../../../roofsafetymanagement-library/src/public-api';

class RoofAreaView {
  constructor(
    public roofArea: RoofareaModel,
    public safetyPointList: SafetyPointModelView[]
  ) { }
}

@Component({
  selector: 'app-object-view',
  templateUrl: './object-view.component.html',
  styleUrl: './object-view.component.scss',
  standalone: false
})
export class ObjectViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  public object: ObjektModel | null = null;
  public roofAreaList: RoofAreaView[] = [];
  public documentList: Document[] = [];    
  public sicherungsSystemList : SicherungssystemModelView[]=[];
  constructor(
    private route: ActivatedRoute,
    private objectService: ObjektService,
    private roofAreaService: RoofareaService,
    private documentService: DocumentService,
    private SicherungssystemViewService: SicherungssystemViewService,
    private safetyPointService: SafetyPointViewService,
    private matDialog: MatDialog
  ) { super(); }

  public async ngOnInit(): Promise<void> {
    var id = this.route.snapshot.params['objectId'];
    try {
      this.loading = true;
      var resultList = await Promise.all([
        this.objectService.get(id),
        this.roofAreaService.getFilteredList({ ObjektID: id }),
        this.safetyPointService.getFilteredList({ ObjektID: id }),      
        this.documentService.getList(),
        this.SicherungssystemViewService.getFilteredList({ObjektID:id})
      ]);
      this.object = resultList[0];
      this.documentList = resultList[3];
      this.roofAreaList = resultList[1].map(roofArea => new RoofAreaView(roofArea, resultList[2].filter(safetyPoint => safetyPoint.RoofareaId == roofArea.RoofareaID)));
      this.sicherungsSystemList = resultList[4];
    } finally {
      this.loading = false;
    }
  }

    getDokumentList(safetyPoint: SafetyPointModelView){        
        return this.documentList.filter(x=>x.DataTypeID == DocumentDataType.SafetyPoint && x.DataID == safetyPoint.SafetyPointId)
    }
  public async openSafetyPointDialog(safetyPoint: SafetyPointModelView | null, roofAera: RoofareaModel|null,objekt: ObjektModel|null): Promise<void> {
    
    var objektID = (roofAera?.ObjektID)?roofAera?.ObjektID: objekt?.ObjektID;
    if(!safetyPoint){
           safetyPoint  = {
            Image:"",
            Bezeichnung : "",
            SafetyPointId:0,
            SicherungssystemID:0,
            DebitorID:0,
            Debitornummer:"",
            ElectronicId:null,
            AssetLink:null,
            Erledigt:false,
            FormId:0,
            FormName:"",
            LandID:0,
            LandName:"",
            Latitude:null,
            Longitude:null,     
            RoofareaId : roofAera?.RoofareaID!,
            ObjektID:   objektID!
         }
    }

    var data = new DialogData(safetyPoint, safetyPoint?.SafetyPointId ? 'edit' : 'create');
    //data.referentCallerID = this.object?.ObjektID!;
    await firstValueFrom(this.matDialog.open(CreateSafetyPointComponent, { data: data }).afterClosed());
    this.ngOnInit();
  }

  public getSicherungsliste(dachflaecheID: number){
      if(!dachflaecheID) return [];
      return this.sicherungsSystemList.filter(x=>x.RoofareaID == dachflaecheID)
  }
}
